export const zipCodeValidator = (zip) => /^[0-9]{5}$/.test(zip);